import styles from "./ReportStory.module.css";
import Icon from "../../../common/Icon";

interface ReportStoryProps {
    checkForm: () => void;
}

const ReportStory = (props: ReportStoryProps) => {
    const reportReasons = ["영리목적/홍보", "개인정보 노출", "욕설/인신공격", "음란/선정성", "불법정보", "도배", "도움이 되지 않음"];

    const handleChange = () => {
        props.checkForm();
    }

    return (
        <div className={styles.wrapper}>
          {reportReasons.map((reason, idx) => {
            const id = `reportReason-${idx}`;
            return (
              <label key={idx} htmlFor={id} className={styles.item}>
                <span className={styles.text}>{reason}</span>
    
                {/* 동작은 라디오 */}
                <input
                  id={id}
                  className={styles.input}
                  type="radio"
                  name="reportReason"
                  value={idx}
                  onChange={handleChange}
                />
    
                {/* 모양은 체크박스 + 체크 아이콘 */}
                <div className={styles.checkbox} aria-hidden="true">
                  <Icon className={styles.icon} name="check" color="white" size="medium" />
                </div>
              </label>
            );
          })}
        </div>
      );
};

export default ReportStory;
